import { createElementObject, createOverlayComponent } from '@react-leaflet/core';
import { Popup as LeafletPopup } from 'leaflet';
import { useEffect } from 'react';
export var Popup = createOverlayComponent(function createPopup(props, context) {
  var popup = new LeafletPopup(props, context.overlayContainer);
  return createElementObject(popup, context);
}, function usePopupLifecycle(element, context, _ref, setOpen) {
  var position = _ref.position;
  useEffect(function addPopup() {
    var instance = element.instance;

    function onPopupOpen(event) {
      if (event.popup === instance) {
        instance.update();
        setOpen(true);
      }
    }

    function onPopupClose(event) {
      if (event.popup === instance) {
        setOpen(false);
      }
    }

    context.map.on({
      popupopen: onPopupOpen,
      popupclose: onPopupClose
    });

    if (context.overlayContainer == null) {
      // Attach to a Map
      if (position != null) {
        instance.setLatLng(position);
      }

      instance.openOn(context.map);
    } else {
      // Attach to container component
      context.overlayContainer.bindPopup(instance);
    }

    return function removePopup() {
      var _context$overlayConta;

      context.map.off({
        popupopen: onPopupOpen,
        popupclose: onPopupClose
      });
      (_context$overlayConta = context.overlayContainer) == null ? void 0 : _context$overlayConta.unbindPopup();
      context.map.removeLayer(instance);
    };
  }, [element, context, setOpen, position]);
});